import { createFileRoute } from "@tanstack/react-router";
import TennisclubSoftware from "@/pages/TennisclubSoftware";

export const Route = createFileRoute("/tennisclub-software")({
  head: () => ({
    meta: [
      { title: "Tennisclub software voor husselavonden, toss & ledenbeheer | De Hussel App" },
      { name: "description", content: "Tennisclub software bespaart vrijwilligers uren werk. Ontdek welke functionaliteit een moderne tennisvereniging nodig heeft — en hoe De Hussel App helpt." },
      { property: "og:title", content: "Tennisclub software voor husselavonden, toss & ledenbeheer | De Hussel App" },
      { property: "og:description", content: "Tennisclub software bespaart vrijwilligers uren werk. Ontdek welke functionaliteit een moderne tennisvereniging nodig heeft — en hoe De Hussel App helpt." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/tennisclub-software" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/tennisclub-software" }],
  }),
  component: TennisclubSoftware,
});
